import React from "react"
import { Link } from "gatsby"
import { Grid, Box, Text } from "theme-ui"

export default function TheGame() {
  return (
    <Grid variant="textWrap">
      <Box>
        <Text as="p" variant="bodyLarge">Quest is a game that creates a fantastic story. The rules help you imagine what happens. You’ll create a unique character, then say what they do. You can seek treasure, glory, justice, revenge, or anything you want. The possibilities are endless.</Text>
        <Text as="p" variant="bodyLarge">You can play Quest to make a short story in one session, or for an epic adventure that lasts for months or years. You can’t lose the game, but everyone wins if you tell a memorable story and have a good time.</Text>
        <Text as="p" variant="bodyLarge">Here you can learn the basic rules of Quest, which you can also find in Chapter 1 of our <Link to="/store/game-book"><Text variant="link">Game Book</Text></Link>. Chapter 2, which you can find in the full book helps you create a character and choose from Quest’s deep catalog of special abilities.</Text>
      </Box>
    </Grid>
  )
}